import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * The selected Klaviyo account ("site"). '' = all accounts (allowed on Home, Popups,
 * Subscribers only). Every site-scoped request passes `siteId` from here.
 */
export const useSite = create(persist((set) => ({
  siteId: '',
  sites: [],
  /**
   * False until /api/sites has answered in this browser session. `sites` is persisted
   * so pages render instantly, but that copy can be hours old, so anything that judges
   * an account (Klaviyo connected, health) must wait for this rather than accuse a
   * connected account of having no key.
   */
  loaded: false,
  setSiteId: (siteId) => set({ siteId }),
  setSites: (sites) => set((s) => ({ sites, loaded: true, siteId: s.siteId && !sites.some((x) => x.id === s.siteId) ? '' : s.siteId })),
}), { name: 'pm-site', partialize: (s) => ({ siteId: s.siteId, sites: s.sites }) }))

export const useCurrentSite = () => useSite((s) => s.sites.find((x) => x.id === s.siteId) ?? null)
